import * as Types from '../../../api/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type DepartmentLevelsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DepartmentLevelsQuery = { __typename?: 'Query', departments: { __typename?: 'Departments', levels: Array<{ __typename?: 'DepartmentLevelWithName', name: string, isDefault: boolean, level: Types.DepartmentLevel }> } };


export const DepartmentLevelsDocument = gql`
    query DepartmentLevels {
  departments {
    levels {
      name
      isDefault
      level
    }
  }
}
    `;

/**
 * __useDepartmentLevelsQuery__
 *
 * To run a query within a React component, call `useDepartmentLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentLevelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDepartmentLevelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentLevelsQuery, DepartmentLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DepartmentLevelsQuery, DepartmentLevelsQueryVariables>(DepartmentLevelsDocument, options);
      }
export function useDepartmentLevelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentLevelsQuery, DepartmentLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DepartmentLevelsQuery, DepartmentLevelsQueryVariables>(DepartmentLevelsDocument, options);
        }
// @ts-ignore
export function useDepartmentLevelsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentLevelsQuery, DepartmentLevelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentLevelsQuery, DepartmentLevelsQueryVariables>;
export function useDepartmentLevelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentLevelsQuery, DepartmentLevelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentLevelsQuery | undefined, DepartmentLevelsQueryVariables>;
export function useDepartmentLevelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentLevelsQuery, DepartmentLevelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DepartmentLevelsQuery, DepartmentLevelsQueryVariables>(DepartmentLevelsDocument, options);
        }
export type DepartmentLevelsQueryHookResult = ReturnType<typeof useDepartmentLevelsQuery>;
export type DepartmentLevelsLazyQueryHookResult = ReturnType<typeof useDepartmentLevelsLazyQuery>;
export type DepartmentLevelsSuspenseQueryHookResult = ReturnType<typeof useDepartmentLevelsSuspenseQuery>;
export type DepartmentLevelsQueryResult = Apollo.QueryResult<DepartmentLevelsQuery, DepartmentLevelsQueryVariables>;